import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { LucideIcon } from "lucide-react";

interface DashboardCard {
  title: string;
  description: string;
  icon: LucideIcon;
  path: string;
}

interface DashboardSectionProps {
  title: string;
  cards: DashboardCard[];
}

export const DashboardSection = ({ title, cards }: DashboardSectionProps) => {
  const navigate = useNavigate();

  if (cards.length === 0) return null;

  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-muted-foreground mb-4 uppercase tracking-wide text-xs">
        {title}
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <Card
              key={card.path}
              className="cursor-pointer hover:shadow-lg hover:border-primary/30 transition-all"
              onClick={() => navigate(card.path)}
            >
              <CardHeader className="p-4 sm:p-5">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-primary/10 rounded-lg">
                    <Icon className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <CardTitle className="text-base">{card.title}</CardTitle>
                    <CardDescription className="text-xs mt-1">{card.description}</CardDescription>
                  </div>
                </div>
              </CardHeader>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
